import React from "react";
import dayjs from "dayjs";
import TicketSelects from "./TicketSelects";
import IconButton from "@mui/joy/IconButton";
import Checkbox from "@mui/material/Checkbox";
import relativeTime from "dayjs/plugin/relativeTime";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import { useNavigate } from "react-router-dom";
import { EndPoints } from "../../../../utils/apiEndpoints";
import { CardAvatar } from "../../../../common/GlobalFunctions";
import { darkModeBackgroud } from "../../../../utils/constants";
import { useLanguageStore } from "../../../../store/useLanguageStore";
import { useDarkModeStore } from "../../../../store/useDarkModeStore";
import { TicketInterface } from "../../../../models/TicketModule/Ticket";
import { TicketImageInterface } from "../../../../models/TicketModule/TicketImage";

dayjs.extend(relativeTime);
interface AssetCardProps {
  ticket: TicketInterface;
  page: number;
  pageSize: number;
  selectedIds: string[];
  setOpenPhotoModal: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      photos: TicketImageInterface[];
    }>
  >;
  setOpenFeedbackModal: React.Dispatch<
    React.SetStateAction<{
      isOpen: boolean;
      ticketId: string;
    }>
  >;
  setSelectedIds: React.Dispatch<React.SetStateAction<string[]>>;
}

export const TicketCard: React.FC<AssetCardProps> = ({
  ticket,
  page,
  pageSize,
  selectedIds,
  setSelectedIds,
  setOpenPhotoModal,
  setOpenFeedbackModal,
}) => {

  const navigation = useNavigate();
  const { language } = useLanguageStore();
  const { darkMode } = useDarkModeStore();

  const isChecked = selectedIds.some((select) => select === ticket.id);
  const isLessThanOneHourOld = React.useMemo(() => ticket.createdDate
    ? dayjs().diff(dayjs(ticket.createdDate), 'hour') < 1
    : false,
    [ticket.createdDate]
  );

  const handleCheckedItem = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;

    if (ticket.id) {
      if (checked) {
        setSelectedIds((prevSelectedIds) => [
          ...prevSelectedIds,
          ticket.id as string,
        ]);
      } else {
        setSelectedIds((prevSelectedIds) =>
          prevSelectedIds.filter((id) => id !== (ticket.id as string))
        );
      }
    }
  };

  const TicketInfo = () => {
    return (
      <div
        title={ticket?.description}
        className="d-flex flex-column gap-1"
      >
        <span>
          {
            isLessThanOneHourOld
            && <span
              className="badge"
              title={language['NewTicketBadge']}
              style={{ background: "#E0F5F0", color: "#007D71" }}
            >
              New
            </span>
          }
        </span>
        <div
          className={`${darkMode ? "text-white" : "text-muted"
            } d-flex flex-row align-items-center gap-1`}
        >
          -- |
          <div
            className={`${darkMode ? "text-white" : "text-dark"
              }fw-bold text-truncate`}
            style={{ fontSize: 13, maxWidth: "200px" }}
          >
            {ticket?.title}
          </div>
          {ticket?.ticketNo ? `#${ticket?.ticketNo}` : ''}
        </div>
        <span
          className={`d-flex flex-row gap-2 ${darkMode && "text-white"}`}
          style={{ fontSize: 13 }}
        >
          <span>
            {ticket.author?.firstname ?? ""} {ticket.author?.lastname ?? ""}
          </span>
          <span className={`${darkMode ? "text-white" : "text-muted"}`}>
            ● {language["Created"]}:{" "}
            {ticket.createdDate ? dayjs(ticket.createdDate).fromNow() : ""}
          </span>
        </span>
      </div>
    );
  };

  return (
    <div
      className="card d-flex flex-row align-items-center gap-2 p-3 card-assets position-relative card-feedback"
      style={{
        borderRadius: 2,
        background: darkMode ? darkModeBackgroud : "white",
      }}
      role="button"
      onClick={() => navigation(`${EndPoints.TICKETS}/view/${ticket.id}`)}
    >
      <div
        className="position-absolute showIconHover d-flex flex-row gap-1"
        style={{ top: 2, right: 2 }}
      >
        <IconButton
          aria-label="edit"
          title="Photos"
          sx={{ color: darkMode ? 'white' : "#185EA5" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpenPhotoModal({ isOpen: true, photos: ticket.images || [] });
          }}
        >
          <PhotoLibraryIcon sx={{ width: 15, height: 15 }} />
        </IconButton>
        <IconButton
          aria-label="edit"
          title="Feedbacks"
          sx={{ color: darkMode ? 'white' : "#185EA5" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setOpenFeedbackModal({ isOpen: true, ticketId: ticket.id || "" });
          }}
        >
          <ChatOutlinedIcon sx={{ width: 15, height: 15 }} />
        </IconButton>
        <IconButton
          aria-label="edit"
          title="Edit Item"
          sx={{ color: darkMode ? 'white' : "#185EA5" }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            navigation(`${EndPoints.TICKETS}/edit/${ticket.id}`);
          }}
        >
          <CreateRoundedIcon sx={{ width: 15, height: 15 }} />
        </IconButton>
      </div>
      <Checkbox
        checked={isChecked}
        onChange={handleCheckedItem}
        onClick={(e) => e.stopPropagation()}
        style={{ color: darkMode ? 'white' : 'initial' }}
      />
      {CardAvatar('T')}
      <TicketInfo />
      <TicketSelects
        page={page}
        ticket={ticket}
        pageSize={pageSize}
      />
    </div>
  );
};
export default TicketCard;
